import * as React from 'react'
import cc from 'classcat'
import LightBox from 'react-images'
import Image from 'gatsby-image'
import Carousel from 'nuka-carousel'
import CaretUp from '../../components/Icons/CaretUp'
import { getSrcSet } from '../../utils/images'

import s from './styles.module.css'

const desktop =
  typeof window !== 'undefined' && window.matchMedia('(min-width: 1024px)')
const tablet =
  typeof window !== 'undefined' && window.matchMedia('(min-width: 767px)')

export default class Gallery extends React.Component {
  getNumberOfThumbnails = () => {
    if (desktop.matches) {
      return 5
    } else if (tablet.matches) {
      return 3
    } else {
      return 1
    }
  }

  state = {
    open: false,
    current: 0,
    numberOfThumbnails: this.getNumberOfThumbnails()
  }

  updateNumberOfThumbnails = () => {
    this.setState({ numberOfThumbnails: this.getNumberOfThumbnails() })
  }

  componentDidMount() {
    desktop.addListener(this.updateNumberOfThumbnails)
    tablet.addListener(this.updateNumberOfThumbnails)
  }

  componentWillUnmount() {
    desktop.removeListener(this.updateNumberOfThumbnails)
    tablet.removeListener(this.updateNumberOfThumbnails)
  }

  onClick = idx => () => {
    this.setState({ current: idx, open: true })
  }

  onClose = () => {
    this.setState({ open: false })
  }

  onClickPrev = () => {
    this.setState(state => ({
      current: state.current === 0 ? state.current : state.current - 1
    }))
  }

  onClickNext = () => {
    this.setState(state => ({
      current:
        state.current === this.props.images.length - 1
          ? state.current
          : state.current + 1
    }))
  }

  render() {
    const {
      images,
      className,
      thumbnailsClassName,
      thumbnailClassName
    } = this.props

    const { open, current, numberOfThumbnails } = this.state

    return (
      <div className={cc([s.gallery, className])}>
        <LightBox
          isOpen={open}
          onClickPrev={this.onClickPrev}
          onClickNext={this.onClickNext}
          currentImage={current}
          onClose={this.onClose}
          images={images.map(getSrcSet)}
        />
        <Carousel
          swiping
          cellAlign="left"
          framePadding={numberOfThumbnails <= 1 ? '' : '0px 70px'}
          slidesToShow={numberOfThumbnails}
          slidesToScroll={numberOfThumbnails}
          cellSpacing={1}
          className={cc([s.thumbnails, thumbnailsClassName])}
          slideIndex={0}
          renderBottomCenterControls={Function.prototype}
          renderCenterLeftControls={({ previousSlide }) => (
            <button className={s.arrowButton} onClick={previousSlide}>
              <CaretUp className={cc([s.arrow, s.left])} />
            </button>
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <button className={s.arrowButton} onClick={nextSlide}>
              <CaretUp className={cc([s.arrow, s.right])} />
            </button>
          )}
          ref={el => {
            this.carouselEl = el
          }}
        >
          {images.map((image, idx) => (
            <button
              key={idx}
              className={cc([s.thumbnail, thumbnailClassName])}
              onClick={this.onClick(idx)}
            >
              <Image
                outerWrapperClassName={s.thumbnailImg}
                className={s.thumbnailImg}
                sizes={image.sizes}
              />
            </button>
          ))}
        </Carousel>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Gallery/index.js